
























































































































































































































































































import PageLoader from '@/components/page-loader/page-loader.vue';
import { CONFIG } from '@/config';
import { Http } from '@/decorators';
import { ApprovalHierarchyType, SalesChannel } from '@/modules/direct-sales/enums';
import { Size } from '@/enums';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { notificationService } from '@/services';
import { DAP_ROUTES } from '@/modules/dap/router';
import { debug } from 'util';
import { AxiosError, AxiosResponse } from 'axios';
import { httpService } from '@/services';

declare const $: any;

@Component({
  components: {
    PageLoader
  }
})
export default class DirectSalesDistributionByDealerPage extends Vue {
  @Prop({ required: true })
  public projectId: number;

  @Prop({ required: true })
  public storeId: number;
  public moment = moment;

  public state: any = {
    channelNames: {
      Fleet: 'FROTISTA',
      RentalAgency: 'LOCADORA',
      DisabledPerson: 'PCD',
      TaxiDriver: 'TAXISTA',
      RuralProducer: 'PRODUTOR RURAL',
      Government: 'GOVERNO',
      AutoEscota: 'AUTO ESCOLA',
      Others: 'OUTROS'
    },
    data: [],
    entries: [],
    channels: [],
    selectedHierarchy: 0,
    aprovalHierarchyUser: 0,
    idApprovalFlowEvent: 0,
    idDealer: 0
  };

  public Size = Size;

  public get years() {
    return _.uniq(this.periods.map((p: any) => p.year));
  }

  public get periods() {
    return _([
      ...this.state.data[0].consolidate_RapFamilyResultsPerMonth,
      ...this.state.data[0].forecast_RapFamilyResultsPerMonth.map((f: any) => {
        return { ...f, forecast: true };
      })
    ])
      .map((f: any) => ({
        month: f.month,
        year: f.year,
        monthName: (moment.localeData() as any)._monthsShort[f.month - 1],
        editable: f.editable || false,
        forecast: f.forecast || false
      }))
      .uniqBy((f: any) => `${f.year}${f.month}`)
      .orderBy((f: any) => f.month)
      .orderBy((f: any) => f.year)
      .value();
  }

  public get models() {
    const models = _(this.state.data)
      .groupBy((data: any) => ApprovalHierarchyType[data.approvalHierarchy])
      .map((data: any) => {
        return _([...data[0].consolidate_RapFamilyResultsPerMonth, ...data[0].forecast_RapFamilyResultsPerMonth])
          .orderBy((family: any) => family.familyName)
          .groupBy((family: any) => family.familyName)
          .map((family: any[], name: string) => ({
            name,
            values: this.createMonthlyValues(SalesChannel.All, family),
            channels: _.reduce(
              this.state.channelNames,
              (acc: any, text: string, name: string) => {
                const channels = _.find(this.state.channels, (c: any) => c.value === family[0].idFamily)
                  .saleChannelDtos;
                if (_.size(channels)) {
                  if (_.some(channels, (c: any) => c.idSaleChannelAggregate === SalesChannel[name])) {
                    acc[name] = this.createMonthlyValues(SalesChannel[name], family);
                  }
                } else {
                  acc[name] = this.createMonthlyValues(SalesChannel[name], family);
                }
                return acc;
              },
              {}
            )
          }))
          .value();
      })
      .value();

    return models;
  }

  public onTabClick(id: number) {
    this.state.selectedHierarchy = id;
  }

  public hasErrors() {
    return _.some(this.models[this.state.selectedHierarchy], (model: any) => {
      return this.verifyChannel(model);
    });
  }

  public showButtonSave() {
    return _.some(this.models[this.state.selectedHierarchy], (model: any) => {
      return _.some(model.values, (m: any) => {
        return m.editable;
      });
    });
  }

  public verifyChannel(model: any) {
    return _.some(this.periods, (period: any) => {
      const expectedValue = _(model.values)
        .filter((val: any) => val.month === period.month && val.year === period.year)
        .sumBy('value');

      const actualValue = _(model.channels)
        .values()
        .flatten()
        .filter((val: any) => val.month === period.month && val.year === period.year)
        .sumBy('value');

      return expectedValue !== actualValue;
    });
  }

  public goBack() {
    window.history.back();
  }

  public verifyModel(model: any, index: number) {
    const expectedValue = this.models[this.state.selectedHierarchy]
      .filter((val: any) => val.name === model.name)
      .reduce((acc: any, val: any) => (acc += +val.values[index].value), 0);

    const actualValue = Object.values(model.channels).reduce((acc, val: any) => (acc += val[index].value), 0);

    return expectedValue !== actualValue;
  }

  public onModelEdit(model: any, channel: any, item: any) {
    item.updatedAt = new Date();
    this.state.entries = _.filter(this.state.entries, (v: any) => v.idEntity !== item.idEntity);
    this.state.entries.push(item);

    //Update source data.
    this.state.data[this.state.selectedHierarchy].forecast_RapFamilyResultsPerMonth.find(
      v => v.idEntity == item.idEntity
    ).value = item.value;
    this.state.data[this.state.selectedHierarchy].forecast_RapFamilyResultsPerMonth.find(
      v => v.idEntity == item.idEntity
    ).updatedAt = item.updatedAt;
  }

  public showPopup(event) {
    $(event.target)
      .popup({ inline: true })
      .popup('toggle');
  }

  @Http('get', `${CONFIG.URL.NEODASH_API}/api/dap/approval/family/channels`)
  @Http(
    'get',
    ({ projectId, storeId }) => `${CONFIG.URL.NEODASH_API}/api/dap/approval/${projectId}/rap/response/${storeId}`
  )
  public getInitial(params?: any, error?, data?) {
    if (error) {
      return;
    }

    this.state.aprovalHierarchyUser = _(data[1])
      .filter((f: any) => f.permitAlter == true)
      .map((m: any) => m.approvalHierarchyUser)
      .value()[0];

    this.state.idApprovalFlowEvent = _(data[1])
      .filter((f: any) => f.permitAlter == true)
      .map((m: any) => m.idApprovalFlowEvent)
      .value()[0];

    this.state.idDealer = _(data[1])
      .filter((f: any) => f.permitAlter == true)
      .map((m: any) => m.idDealer)
      .value()[0];

    this.state.channels = data[0];
    this.state.data = data[1];
    this.state.selectedHierarchy = this.state.data.length - 1;
  }

  @Http(
    'put',
    ({ projectId, storeId, state }) =>
      `${CONFIG.URL.NEODASH_API}/api/dap/approval/${projectId}/rap/response/${storeId}/${state.selectedHierarchy}`,
    ({ state }) => state.entries
  )
  public updateModels() {
    notificationService.sendToast({
      status: 1,
      type: 'success',
      message: 'Registros salvos com sucesso!'
    });
  }

  public updateModelsFinalize() {
    var obj = {
      IdProject: this.projectId,
      IdStoreProject: this.state.idDealer,
      Hierachy: this.state.aprovalHierarchyUser,
      Dtos: this.state.entries,
      IdApprovalFlowEvent: this.state.idApprovalFlowEvent
    };

    const req = [
      httpService.http.put(
        `${CONFIG.URL.NEODASH_API}/api/dap/approval/${this.projectId}/rap/response/finalize/${this.storeId}/${
          this.state.aprovalHierarchyUser
        }`,
        obj
      )
    ];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        this.getInitial();
        notificationService.sendToast({
          status: 1,
          type: 'success',
          message: 'Registros salvos com sucesso!'
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  private createMonthlyValues(channelId: number, family: any[]) {
    const values = _.reduce(
      this.periods,
      (acc: any[], period: any) => {
        const entries: any[] = _.filter(
          family,
          (f: any) =>
            f.month === period.month &&
            f.year === period.year &&
            (channelId === SalesChannel.All ? true : f.saleChannel.idSaleChannelAggregate === channelId)
        );
        acc.push({ ...period, ...entries[0], value: _.sumBy(entries, (e: any) => +e.value) });
        return acc;
      },
      []
    );

    return _.map(values, (f: any) => ({
      updatedAt: null,
      ...f,
      monthName: (moment.localeData() as any)._monthsShort[f.month - 1],
      idSaleChannel: (f.saleChannel || {}).id,
      editable: channelId === SalesChannel.Others || !f.idEntity ? false : f.editable || false
    }));
  }

  public confirmFinal() {
    $(this.$refs.promptDialog)
      .modal({
        closable: false,
        // onDeny: () => {},
        onApprove: () => {
          $('#file-upload-widget').trigger('click');
        }
      })
      .modal('show');
  }

  public async mounted() {
    this.getInitial();
  }
}
